import React, { useState, useEffect } from 'react';
import { Input } from '@material-tailwind/react';

const DebouncedInput = ({ value: initialValue, onChange, delay = 500, ...props }) => {
  const [value, setValue] = useState(initialValue || '');

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    if (value !== initialValue) {
      const handler = setTimeout(() => {
        onChange(value);
      }, delay);
  
      return () => {
        clearTimeout(handler);
      };
    }
  }, [value, delay, onChange, initialValue]);

  return (
    <Input
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
};

export default DebouncedInput;
